import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Environment } from 'src/environment';

import {
  Cycle,
  CyclesResponse,
  PropagationCompaniesResponse,
  PropagationCompany,
  UpsertCycleResponse,
} from '../models/cycle.model';

@Injectable({
  providedIn: 'root',
})
export class PoultryNextRearingService {
  private baseUrl = `${this.env.API_BASE_URL}/service/poultrynext-rearing/secure`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  // get cycles
  getCycles(): Observable<Cycle[] | HttpErrorResponse> {
    return this.http.get<CyclesResponse>(`${this.baseUrl}/cycle`, {}).pipe(
      map((response) => response.cycles),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Cycle[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  // post cycles
  upsertCycle(cycle: Cycle): Observable<UpsertCycleResponse | HttpErrorResponse> {
    return this.http.post<UpsertCycleResponse>(`${this.baseUrl}/cycle`, { ...cycle }, {}).pipe(
      map((d) => d),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<UpsertCycleResponse>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  // delete cycle
  deleteCycle(id: number) {
    return this.http.delete(`${this.baseUrl}/cycle/${id}`);
  }

  getPropagationCompanies(): Observable<PropagationCompany[] | HttpErrorResponse> {
    return this.http
      .get<PropagationCompaniesResponse>(`${this.baseUrl}/propagationcompany`, {})
      .pipe(
        map((response) => response.propagationCompanies),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<PropagationCompany[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
